/** Durations are stored as a number of weeks, which reads badly past a year. */
export const courseDuration = (duration) => {
  const value = Number(duration);
  if (!Number.isFinite(value) || value <= 0) return duration || null;
  return value >= 52 ? `${(value / 52).toFixed(1).replace(/\.0$/, "")} yrs` : `${value} wks`;
};

/** Fees are free text in the catalogue, so anything that is not a real amount is not shown. */
export const courseMoney = (value) => {
  const amount = Number(String(value ?? "").replace(/[^0-9.]/g, ""));
  if (!Number.isFinite(amount) || amount <= 0) return null;
  return `$${amount.toLocaleString("en-AU", { maximumFractionDigits: 0 })}`;
};

export const percent = (value) => {
  const amount = Number(String(value ?? "").replace(/[^0-9.]/g, ""));
  if (!Number.isFinite(amount) || amount <= 0) return null;
  return `${amount}%`;
};
